export type CrewLookupKind =
  | 'ranks'
  | 'nationalities'
  | 'sex-types'
  | 'marital-statuses'
  | 'relations'
  | 'religions'
  | 'manning-agents'
  | 'availability-statuses'
  | 'cert-categories'
  | 'cert-catalogs'
  | 'employment-statuses'
  | 'vessel-types'
  | 'engine-types'
  | 'vessel-owners'
  | 'ecdis-types'
  | 'sign-off-reasons'
  | 'travel-segment-types';

export type CrewLookupExtraField = 'abrv' | 'phone' | 'email' | 'description';

export type CrewLookupDef = {
  kind: CrewLookupKind;
  label: string;
  singular: string;
  extras: CrewLookupExtraField[];
};

export const CREW_LOOKUP_DEFS: CrewLookupDef[] = [
  { kind: 'ranks', label: 'Ranks', singular: 'Rank', extras: ['abrv'] },
  { kind: 'nationalities', label: 'Nationalities', singular: 'Nationality', extras: [] },
  { kind: 'sex-types', label: 'Sex types', singular: 'Sex type', extras: [] },
  { kind: 'marital-statuses', label: 'Marital statuses', singular: 'Marital status', extras: [] },
  { kind: 'relations', label: 'Relations', singular: 'Relation', extras: [] },
  { kind: 'religions', label: 'Religions', singular: 'Religion', extras: [] },
  { kind: 'manning-agents', label: 'Manning agents', singular: 'Manning agent', extras: ['phone', 'email'] },
  { kind: 'availability-statuses', label: 'Availability statuses', singular: 'Availability status', extras: [] },
  { kind: 'cert-categories', label: 'Certificate categories', singular: 'Certificate category', extras: [] },
  { kind: 'cert-catalogs', label: 'Certificate catalog', singular: 'Certificate catalog entry', extras: ['description'] },
  { kind: 'employment-statuses', label: 'Employment statuses', singular: 'Employment status', extras: [] },
  { kind: 'vessel-types', label: 'Vessel types', singular: 'Vessel type', extras: [] },
  { kind: 'engine-types', label: 'Engine types', singular: 'Engine type', extras: [] },
  { kind: 'vessel-owners', label: 'Vessel owners', singular: 'Vessel owner', extras: [] },
  { kind: 'ecdis-types', label: 'ECDIS types', singular: 'ECDIS type', extras: [] },
  { kind: 'sign-off-reasons', label: 'Sign-off reasons', singular: 'Sign-off reason', extras: [] },
  {
    kind: 'travel-segment-types',
    label: 'Travel leg types',
    singular: 'Travel leg type',
    extras: [],
  },
];

const BY_KIND = new Map(CREW_LOOKUP_DEFS.map((d) => [d.kind, d]));

export function getCrewLookupDef(kind: string | undefined): CrewLookupDef | null {
  if (!kind) return null;
  return BY_KIND.get(kind as CrewLookupKind) ?? null;
}

export function crewLookupListPath(kind: CrewLookupKind): string {
  return `/parameters/crew/${kind}`;
}

/** Combined workspace URL for a lookup kind (list view). */
export function crewLookupWorkspacePath(kind: CrewLookupKind): string {
  return `/parameters/crew?section=${kind}`;
}

export function crewLookupApiBase(kind: CrewLookupKind): string {
  return `/crew-lookups/${kind}`;
}
